import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FindAHealthCenterComponent } from './components/find-a-health-center/find-a-health-center.component';

const routes: Routes = [{ path: '', component: FindAHealthCenterComponent }];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
